import axios from "axios";
import store from "@/js/store/index";
import { failedUserStatus } from "@/js/helpers/failedUserStatus";
import { userIsTryingToConnectOtherLiAccount } from "@/js/services/UserService";

export default function setup() {
	axios.interceptors.request.use(requestIntercept, (err) => Promise.reject(err));
	axios.interceptors.response.use((response) => response, responseErrorIntercept);
}

async function requestIntercept(config) {
	const sideAccId = store.getters.sideAccountId;

	let tokenResult;
	tokenResult = await store.dispatch("getTokenResult");
	if (!tokenResult.claims.linkedin_id) {
		tokenResult = await store.dispatch("getTokenResult", true);
	}

	config.headers.common.Authorization = `Bearer ${tokenResult.token}`;

	if (sideAccId) config.headers["X-SIGNED-USER-ID"] = sideAccId;

	return config;
}

function responseErrorIntercept(error) {
	const resp = error.response;
	if (resp) {
		const data = resp.data;
		checkIfBadStatusResponse(data);
	}
	return Promise.reject(error);
}

function checkIfBadStatusResponse(data) {
	if (!data) return;

	const { status, message } = data;

	if (userIsTryingToConnectOtherLiAccount(data)) {
		store.commit("setWrongLiEmailStatus", true);
	}

	if (status === 401 && failedUserStatus(message)) {
		store.dispatch("setUserErrorStatus", message);
	}
}
